import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { PaymentMethodTile } from '../components/PaymentMethodTile';
import { toBengaliNumeral } from '../utils/bengaliHelpers';
export function PaymentPage() {
  const navigate = useNavigate();
  const [selectedMethod, setSelectedMethod] = useState('bkash');
  const methods = [{
    id: 'bkash',
    name: 'বিকাশ',
    logo: '🌸'
  }, {
    id: 'nagad',
    name: 'নগদ',
    logo: '📮'
  }, {
    id: 'rocket',
    name: 'রকেট',
    logo: '🚀'
  }, {
    id: 'card',
    name: 'কার্ড',
    logo: '💳'
  }];
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-342">
      <div className="bg-white sticky top-0 z-30 shadow-sm px-4 py-4 flex items-center space-x-3" data-id="element-343">
        <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-344">
          <ArrowLeft size={24} data-id="element-345" />
        </button>
        <h1 className="font-bold font-bengali text-lg" data-id="element-346">পেমেন্ট</h1>
      </div>

      <div className="p-4 space-y-6" data-id="element-347">
        {/* Summary */}
        <div className="bg-white p-5 rounded-2xl border border-gray-200" data-id="element-348">
          <div className="flex justify-between mb-2" data-id="element-349">
            <span className="text-gray-600 font-bengali" data-id="element-350">
              টিকিট মূল্য (১ জন)
            </span>
            <span className="font-bold font-bengali" data-id="element-351">৳৩৫০</span>
          </div>
          <div className="flex justify-between mb-2" data-id="element-352">
            <span className="text-gray-600 font-bengali" data-id="element-353">সার্ভিস চার্জ</span>
            <span className="font-bold font-bengali" data-id="element-354">৳২০</span>
          </div>
          <div className="h-px bg-gray-200 my-3" data-id="element-355" />
          <div className="flex justify-between text-lg" data-id="element-356">
            <span className="font-bold text-gray-900 font-bengali" data-id="element-357">
              মোট প্রদেয়
            </span>
            <span className="font-bold text-[#006a4e] font-bengali" data-id="element-358">৳৩৭০</span>
          </div>
        </div>

        {/* Methods */}
        <div data-id="element-359">
          <h3 className="font-bold text-gray-900 font-bengali mb-4" data-id="element-360">
            পেমেন্ট মেথড নির্বাচন করুন
          </h3>
          <div className="grid grid-cols-2 gap-4" data-id="element-361">
            {methods.map(method => <PaymentMethodTile key={method.id} {...method} selected={selectedMethod === method.id} onSelect={() => setSelectedMethod(method.id)} data-id="element-362" />)}
          </div>
        </div>

        {/* Security Note */}
        <div className="flex items-center justify-center space-x-2 text-green-700 bg-green-50 p-3 rounded-lg" data-id="element-363">
          <ShieldCheck size={18} data-id="element-364" />
          <span className="text-xs font-bold font-bengali" data-id="element-365">
            ১০০% নিরাপদ পেমেন্ট
          </span>
        </div>

        <button onClick={() => navigate('/eticket')} className="w-full bg-[#006a4e] text-white py-4 rounded-xl font-bold text-xl font-bengali shadow-lg shadow-green-200 mt-4" data-id="element-366">
          পেমেন্ট নিশ্চিত করুন
        </button>
      </div>
    </div>;
}